import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaSwitch from './VaSwitch.vue'

export const VaSwitch = withConfigTransport(_VaSwitch)
